import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

export const UnableToLoginPage = () => {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            sx={{ pr: 1, pl: 1 }}
        >
            <div>
                <Typography variant='h6' align='center' sx={{ mb:1 }}>
                    {t('Please check your clock settings.')}
                </Typography>
                <Typography variant='subtitle1' align='center'>
                    {t('Sorry, we are unable to log you in because of a time mismatch between your device and our servers.')}
                </Typography>
            </div>
        </Box>
    );
};